import { render, staticRenderFns } from "./QuestionnaireCardItem.vue?vue&type=template&id=2507a4fe&scoped=true&"
import script from "./QuestionnaireCardItem.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireCardItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireCardItem.vue?vue&type=style&index=0&id=2507a4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2507a4fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
